import React from 'react';
import Div100vh from 'modules/utils/cp3/components/Div100vh';
import mapImage from 'images/map.png';
import { WORLD_MAP } from '../constants';
import { StyledMapSection, StyledMapImage } from '../styles';

const MapSection = () => (
	<StyledMapSection>
		<Div100vh>
			<StyledMapImage src={mapImage} alt={WORLD_MAP} />
		</Div100vh>
	</StyledMapSection>
);

export default MapSection;
